// deps
import React from "react";

// interfaces
import { DEFAULT_ANALYTICS_CONTEXT_VALUE, AnalyticsEventPayload } from "@swiggy-private/analytics";

export interface AnalyticsContextValue {
    clickEvent: (payload: AnalyticsEventPayload) => void;
    impressionEvent: (payload: AnalyticsEventPayload) => void;
    screenViewEvent: (payload: AnalyticsEventPayload) => void;
}

export const AnalyticsContext = React.createContext<AnalyticsContextValue>(DEFAULT_ANALYTICS_CONTEXT_VALUE);
